import React from 'react';
import { createRoot } from 'react-dom/client';

import { FAQAccordion } from '@shared/FAQAccordion';

const OPERATOR_NAMES = {
  la_poste_count: 'La Poste',
  sgs_count: 'ObjectifCode',
  codengo_count: "Code'nGo",
  dekra_count: 'Dekra',
  pointcode_count: 'Pointcode',
};

function buildFaqList(city, stats) {
  const total = stats.exam_centers_count;
  if (!total) return null;

  const breakdown = Object.entries(OPERATOR_NAMES)
    .filter(([key]) => stats[key] > 0)
    .map(([key, name]) => `${stats[key]} centre${stats[key] > 1 ? 's' : ''} ${name}`);
  const breakdownStr =
    breakdown.length > 1
      ? `${breakdown.slice(0, -1).join(', ')} et ${breakdown[breakdown.length - 1]}`
      : breakdown[0] || '';

  return {
    sections: [
      {
        title: null,
        questions: [
          {
            id: 'city-1',
            question: `Combien y'a-t-il de centres d'examen du code à ${city} ?`,
            answer: `${city} compte <strong>${total} centre${
              total > 1 ? 's' : ''
            } d'examen du code de la route</strong>${
              breakdownStr ? `, dont ${breakdownStr}.` : '.'
            }`,
          },
          {
            id: 'city-2',
            question: `Comment s'inscrire à l'examen du code de la route à ${city} ?`,
            answer: `Vous pouvez réserver votre place d'examen du code de la route en quelques clics sur VroomVroom.fr. Pour cela, sélectionnez un centre d'examen à ${city}. La liste des sessions disponibles est mise à jour en temps réel. Créez votre compte et procédez au paiement. Vous recevrez la convocation par email quelques secondes plus tard.`,
          },
          {
            id: 'city-3',
            question: `Combien coûte l'examen du code à ${city} ?`,
            answer:
              "Le tarif de l'examen du code est identique dans toute la France, il est fixé par l'État. Son prix est de <strong>30€ TTC</strong>. Vous pouvez régler en carte bancaire sur VroomVroom.fr.",
          },
          {
            id: 'city-4',
            question: "Quels sont les documents nécessaires pour passer l'examen du code ?",
            answer:
              "Vous aurez besoin de vous présenter à l'examen muni de votre convocation (imprimée ou en format numérique), ainsi que d'une pièce d'identité en cours de validité. En cas de doute sur les pièces acceptées, nous vous conseillons de consulter le site de l'opérateur agréé.",
          },
          {
            id: 'city-5',
            question: 'Quels sont les délais pour recevoir le résultat de mon examen ?',
            answer:
              "Vous recevrez le résultat de votre examen du code de la route dans un délai maximum de 48 heures après votre passage. Le résultat est envoyé par email sur l'adresse renseignée lors de votre inscription. Si vous ne recevez pas votre résultat, consultez votre Espace Personnel ou contactez le service client du centre d'examen.",
          },
        ],
      },
    ],
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const node = document.querySelector('#react-faq-accordion');

  if (node) {
    const cityDataAttr = node.dataset.city;
    if (!cityDataAttr) return;

    let faqList;
    try {
      const { city, stats } = JSON.parse(cityDataAttr);
      faqList = buildFaqList(city, stats);
    } catch (_e) {
      return;
    }

    if (!faqList) return;

    const root = createRoot(node);
    root.render(<FAQAccordion faqList={faqList} />);
  }
});
